import { lazy } from 'react';
import Plugin from '@jbrowse/core/Plugin';
import UCSCTrackHubConnectionF from './ucsc-trackhub';
import AddTrackWidgetF from './AddTrackWidget';
import AddConnectionWidgetF from './AddConnectionWidget';
import PluginStoreWidgetF from './PluginStoreWidget';
import HierarchicalTrackSelectorWidgetF from './HierarchicalTrackSelectorWidget';
const AssemblyManager = lazy(() => import('./AssemblyManager'));
export default class DataManagementPlugin extends Plugin {
    constructor() {
        super(...arguments);
        this.name = 'DataManagementPlugin';
        this.exports = {
            AssemblyManager,
        };
    }
    install(pluginManager) {
        UCSCTrackHubConnectionF(pluginManager);
        AddTrackWidgetF(pluginManager);
        HierarchicalTrackSelectorWidgetF(pluginManager);
        AddConnectionWidgetF(pluginManager);
        PluginStoreWidgetF(pluginManager);
    }
    configure(_pluginManager) { }
}
export { AssemblyManager };
